module.exports = __webpack_public_path__ + "static/media/preloader-Big-FC-withText-combined.d54633a3.gif";